import React from "react";
import './Partenaires.css';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Partenaires extends React.Component {

    render() {
        return (
            <div className="block-partenaires-mid">
                <div className="div_img_part">
                    <img alt={this.props.alt} src={SERVER_ADDRESS + "/images/" + this.props.liens_logo} />
                </div>
                <h3 className="contain-partenaires-mid">{this.props.name}</h3>
                <p className="contain-partenaires-mid">{this.props.description}</p>
                <p className="contain-partenaires-mid-spe">Site web :</p>
                <a className="contain-partenaires-mid" href={this.props.liens_site} rel="noopener noreferrer" target="_blank">{this.props.name}</a>
            </div>
        )
    }
}

export default Partenaires;
